export default function shouldAutoFocusChatInput(mobile) {
    return !mobile
}
